module.exports = __webpack_public_path__ + "img/gzh.2d5c0c5f.jpeg";